"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.MarketplaceAPPWhatsappWebAPIPathGenerator = exports.MarketplaceAppsAPIPathGenerator = exports.CRMActivityAPIPathGenerator = exports.CRMActivityDefinitionAPIPathGenerator = exports.CRMFieldAPIPathGenerator = exports.CRMEntitySearchAPIPathGenerator = exports.CRMContactBulkAPIPathGenerator = exports.CRMContactAPIPathGenerator = exports.EntityConfigurationAPIPathGenerator = exports.OrganisationMemberAPIPathGenerator = exports.InviteMemberAPIPathGenerator = exports.OrganisationAPIPathGenerator = exports.UserAPIPathGenerator = exports.APIPathGenerator = void 0;
var api_path_fragments_1 = require("./api-path-fragments");
var APIPathGenerator = /** @class */ (function () {
    function APIPathGenerator() {
    }
    APIPathGenerator.getPath = function (path, params) {
        if (params === void 0) { params = {}; }
        var resultPath = path;
        for (var param in params) {
            resultPath = resultPath.replace(":".concat(param), params[param]);
        }
        return resultPath;
    };
    APIPathGenerator.buildQueryString = function (params) {
        var query = Object.keys(params)
            .map(function (key) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key])); })
            .join('&');
        return query ? "?".concat(query) : '';
    };
    APIPathGenerator.params = function (queryParams) {
        if (queryParams === void 0) { queryParams = {}; }
        return this.buildQueryString(queryParams);
    };
    return APIPathGenerator;
}());
exports.APIPathGenerator = APIPathGenerator;
var UserAPIPathGenerator = /** @class */ (function (_super) {
    __extends(UserAPIPathGenerator, _super);
    function UserAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserAPIPathGenerator.create = function () {
        return this.USERS; // POST 
    };
    UserAPIPathGenerator.details = function (userId) {
        return this.getPath(this.USERS_ITEM, { userId: userId }); // GET 
    };
    UserAPIPathGenerator.update = function (userId) {
        return this.getPath(this.USERS_ITEM, { userId: userId }); // PUT 
    };
    UserAPIPathGenerator["delete"] = function (userId) {
        return this.getPath(this.USERS_ITEM, { userId: userId }); // DELETE 
    };
    UserAPIPathGenerator.listOrganisations = function (userId) {
        return this.getPath(this.USERS_ORGANISATIONS, { userId: userId }); // GET 
    };
    UserAPIPathGenerator.organisationUser = function (userId, organisationId) {
        return this.getPath(this.ORGANISATION_USER, { userId: userId, organisationId: organisationId }); // GET 
    };
    var _a;
    _a = UserAPIPathGenerator;
    UserAPIPathGenerator.Base_USERS = "/".concat(api_path_fragments_1.APIPathFragments.APP_USERS, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.USERS);
    UserAPIPathGenerator.USERS = "".concat(_a.Base_USERS);
    UserAPIPathGenerator.USERS_ITEM = "".concat(_a.Base_USERS, "/:userId");
    UserAPIPathGenerator.USERS_ORGANISATIONS = "".concat(_a.Base_USERS, "/:userId/").concat(api_path_fragments_1.APIPathFragments.ORGANISATIONS);
    UserAPIPathGenerator.ORGANISATION_USER = "".concat(_a.Base_USERS, "/:userId/").concat(api_path_fragments_1.APIPathFragments.ORGANISATIONS, "/:organisationId");
    return UserAPIPathGenerator;
}(APIPathGenerator));
exports.UserAPIPathGenerator = UserAPIPathGenerator;
var OrganisationAPIPathGenerator = /** @class */ (function (_super) {
    __extends(OrganisationAPIPathGenerator, _super);
    function OrganisationAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganisationAPIPathGenerator.create = function () {
        return this.ORGANISATION; // POST 
    };
    OrganisationAPIPathGenerator.listUsers = function (organisationId) {
        return this.getPath(this.ORGANISATION_USERS, { organisationId: organisationId }); // GET 
    };
    OrganisationAPIPathGenerator.details = function (organisationId) {
        return this.getPath(this.ORGANISATION_ITEM, { organisationId: organisationId }); // GET 
    };
    OrganisationAPIPathGenerator.update = function (organisationId) {
        return this.getPath(this.ORGANISATION_ITEM, { organisationId: organisationId }); // PUT 
    };
    OrganisationAPIPathGenerator["delete"] = function (organisationId) {
        return this.getPath(this.ORGANISATION_ITEM, { organisationId: organisationId }); // DELETE 
    };
    var _b;
    _b = OrganisationAPIPathGenerator;
    OrganisationAPIPathGenerator.Base_ORGANISATION = "/".concat(api_path_fragments_1.APIPathFragments.APP_INFO, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.ORGANISATIONS);
    OrganisationAPIPathGenerator.ORGANISATION = "".concat(_b.Base_ORGANISATION);
    OrganisationAPIPathGenerator.ORGANISATION_ITEM = "".concat(_b.Base_ORGANISATION, "/:organisationId");
    OrganisationAPIPathGenerator.ORGANISATION_USERS = "".concat(_b.Base_ORGANISATION, "/:organisationId/").concat(api_path_fragments_1.APIPathFragments.ORGANISATION_MEMBER);
    OrganisationAPIPathGenerator.INVITE_USER = "".concat(_b.Base_ORGANISATION, "/:organisationId/").concat(api_path_fragments_1.APIPathFragments.INVITE, "/:emailId");
    return OrganisationAPIPathGenerator;
}(APIPathGenerator));
exports.OrganisationAPIPathGenerator = OrganisationAPIPathGenerator;
var InviteMemberAPIPathGenerator = /** @class */ (function (_super) {
    __extends(InviteMemberAPIPathGenerator, _super);
    function InviteMemberAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InviteMemberAPIPathGenerator.get = function (tokenId) {
        return this.getPath(this.INVITE_MEMBER_ITEM, { tokenId: tokenId }); // GET 
    };
    InviteMemberAPIPathGenerator.create = function (organisationId) {
        return this.getPath(this.INVITE_MEMBER, { organisationId: organisationId }); // POST 
    };
    InviteMemberAPIPathGenerator["delete"] = function (organisationId) {
        return this.getPath(this.INVITE_MEMBER, { organisationId: organisationId }); // Delete 
    };
    InviteMemberAPIPathGenerator.resend = function (organisationId) {
        return this.getPath(this.INVITE_MEMBER, { organisationId: organisationId }); // GET 
    };
    InviteMemberAPIPathGenerator.updateUser = function (userId) {
        return this.getPath(this.INVITE_MEMBER_ITEM_USER, { userId: userId }); // PUT 
    };
    var _c;
    _c = InviteMemberAPIPathGenerator;
    InviteMemberAPIPathGenerator.Base_INVITE_MEMBER = "/".concat(api_path_fragments_1.APIPathFragments.APP_INFO, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.INVITE);
    InviteMemberAPIPathGenerator.INVITE_MEMBER = "".concat(_c.Base_INVITE_MEMBER, "/:organisationId");
    InviteMemberAPIPathGenerator.INVITE_MEMBER_ITEM = "".concat(_c.Base_INVITE_MEMBER, "/:tokenId");
    InviteMemberAPIPathGenerator.INVITE_MEMBER_ITEM_USER = "".concat(_c.Base_INVITE_MEMBER, "/").concat(api_path_fragments_1.APIPathFragments.USERS, "/:userId");
    return InviteMemberAPIPathGenerator;
}(APIPathGenerator));
exports.InviteMemberAPIPathGenerator = InviteMemberAPIPathGenerator;
var OrganisationMemberAPIPathGenerator = /** @class */ (function (_super) {
    __extends(OrganisationMemberAPIPathGenerator, _super);
    function OrganisationMemberAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrganisationMemberAPIPathGenerator.create = function () {
        return this.ORGANISATION_MEMBER; // POST 
    };
    OrganisationMemberAPIPathGenerator.details = function (organisationMemberId) {
        return this.getPath(this.ORGANISATION_MEMBER_ITEM, { organisationMemberId: organisationMemberId }); // GET 
    };
    OrganisationMemberAPIPathGenerator.update = function (organisationMemberId) {
        return this.getPath(this.ORGANISATION_MEMBER_ITEM, { organisationMemberId: organisationMemberId }); // PUT 
    };
    OrganisationMemberAPIPathGenerator["delete"] = function (organisationMemberId) {
        return this.getPath(this.ORGANISATION_MEMBER_ITEM, { organisationMemberId: organisationMemberId }); // DELETE 
    };
    var _d;
    _d = OrganisationMemberAPIPathGenerator;
    OrganisationMemberAPIPathGenerator.Base_ORGANISATION_MEMBER = "/".concat(api_path_fragments_1.APIPathFragments.APP_INFO, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.ORGANISATION_MEMBER);
    OrganisationMemberAPIPathGenerator.ORGANISATION_MEMBER = "".concat(_d.Base_ORGANISATION_MEMBER);
    OrganisationMemberAPIPathGenerator.ORGANISATION_MEMBER_ITEM = "".concat(_d.Base_ORGANISATION_MEMBER, "/:organisationMemberId");
    return OrganisationMemberAPIPathGenerator;
}(APIPathGenerator));
exports.OrganisationMemberAPIPathGenerator = OrganisationMemberAPIPathGenerator;
var EntityConfigurationAPIPathGenerator = /** @class */ (function (_super) {
    __extends(EntityConfigurationAPIPathGenerator, _super);
    function EntityConfigurationAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EntityConfigurationAPIPathGenerator.createView = function () {
        return this.ENTITY_VIEW; // POST 
    };
    EntityConfigurationAPIPathGenerator.detailsView = function (entityType) {
        return this.getPath(this.ENTITY_VIEW_ITEM, { entityType: entityType }); // GET 
    };
    EntityConfigurationAPIPathGenerator.updateView = function (entityType) {
        return this.getPath(this.ENTITY_VIEW_ITEM, { entityType: entityType }); // PUT 
    };
    EntityConfigurationAPIPathGenerator.deleteView = function (entityType) {
        return this.getPath(this.ENTITY_VIEW_ITEM, { entityType: entityType }); // DELETE 
    };
    EntityConfigurationAPIPathGenerator.createAdd = function () {
        return this.ENTITY_ADD; // POST 
    };
    EntityConfigurationAPIPathGenerator.detailsAdd = function (entityType) {
        return this.getPath(this.ENTITY_ADD_ITEM, { entityType: entityType }); // GET 
    };
    EntityConfigurationAPIPathGenerator.updateAdd = function (entityType) {
        return this.getPath(this.ENTITY_ADD_ITEM, { entityType: entityType }); // PUT 
    };
    EntityConfigurationAPIPathGenerator.deleteAdd = function (entityType) {
        return this.getPath(this.ENTITY_ADD_ITEM, { entityType: entityType }); // DELETE 
    };
    var _e;
    _e = EntityConfigurationAPIPathGenerator;
    EntityConfigurationAPIPathGenerator.BASE_ENTITY_VIEW = "/".concat(api_path_fragments_1.APIPathFragments.APP_INFO, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.ENTITY_CONFIGURATIONS, "/").concat(api_path_fragments_1.APIPathFragments.VIEW);
    EntityConfigurationAPIPathGenerator.BASE_ENTITY_ADD = "/".concat(api_path_fragments_1.APIPathFragments.APP_INFO, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.ENTITY_CONFIGURATIONS, "/").concat(api_path_fragments_1.APIPathFragments.ADD);
    EntityConfigurationAPIPathGenerator.ENTITY_VIEW = "".concat(_e.BASE_ENTITY_VIEW);
    EntityConfigurationAPIPathGenerator.ENTITY_VIEW_ITEM = "".concat(_e.ENTITY_VIEW, "/:entityType");
    EntityConfigurationAPIPathGenerator.ENTITY_ADD = "".concat(_e.BASE_ENTITY_ADD);
    EntityConfigurationAPIPathGenerator.ENTITY_ADD_ITEM = "".concat(_e.ENTITY_ADD, "/:entityType");
    return EntityConfigurationAPIPathGenerator;
}(APIPathGenerator));
exports.EntityConfigurationAPIPathGenerator = EntityConfigurationAPIPathGenerator;
var CRMContactAPIPathGenerator = /** @class */ (function (_super) {
    __extends(CRMContactAPIPathGenerator, _super);
    function CRMContactAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CRMContactAPIPathGenerator.create = function () {
        return this.CRM_CONTACTS; // POST
    };
    CRMContactAPIPathGenerator.list = function () {
        return this.CRM_CONTACTS_LIST; // Get
    };
    CRMContactAPIPathGenerator.details = function (contactId) {
        return this.getPath(this.CRM_CONTACTS_ITEM, { contactId: contactId }); // GET
    };
    CRMContactAPIPathGenerator.update = function (contactId) {
        return this.getPath(this.CRM_CONTACTS_ITEM, { contactId: contactId }); // Patch
    };
    CRMContactAPIPathGenerator["delete"] = function (contactId) {
        return this.getPath(this.CRM_CONTACTS_ITEM, { contactId: contactId }); // DELETE
    };
    var _f;
    _f = CRMContactAPIPathGenerator;
    CRMContactAPIPathGenerator.BASE_CRM_CONTACTS = "/".concat(api_path_fragments_1.APIPathFragments.CRM, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.OBJECTS, "/").concat(api_path_fragments_1.APIPathFragments.CONTACTS);
    CRMContactAPIPathGenerator.CRM_CONTACTS = "".concat(_f.BASE_CRM_CONTACTS);
    CRMContactAPIPathGenerator.CRM_CONTACTS_ITEM = "".concat(_f.BASE_CRM_CONTACTS, "/:contactId");
    CRMContactAPIPathGenerator.CRM_CONTACTS_LIST = "".concat(_f.BASE_CRM_CONTACTS, "/").concat(api_path_fragments_1.APIPathFragments.LIST);
    return CRMContactAPIPathGenerator;
}(APIPathGenerator));
exports.CRMContactAPIPathGenerator = CRMContactAPIPathGenerator;
var CRMContactBulkAPIPathGenerator = /** @class */ (function (_super) {
    __extends(CRMContactBulkAPIPathGenerator, _super);
    function CRMContactBulkAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CRMContactBulkAPIPathGenerator.create = function () {
        return this.BASE_CRM_CONTACTS_BULK; // POST
    };
    CRMContactBulkAPIPathGenerator.update = function () {
        return this.BASE_CRM_CONTACTS_BULK; // PUT
    };
    CRMContactBulkAPIPathGenerator["delete"] = function () {
        return this.BASE_CRM_CONTACTS_BULK; // DELETE
    };
    CRMContactBulkAPIPathGenerator.BASE_CRM_CONTACTS_BULK = "/".concat(api_path_fragments_1.APIPathFragments.CRM, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.OBJECTS, "/").concat(api_path_fragments_1.APIPathFragments.CONTACTS, "/").concat(api_path_fragments_1.APIPathFragments.BULK);
    return CRMContactBulkAPIPathGenerator;
}(APIPathGenerator));
exports.CRMContactBulkAPIPathGenerator = CRMContactBulkAPIPathGenerator;
var CRMEntitySearchAPIPathGenerator = /** @class */ (function (_super) {
    __extends(CRMEntitySearchAPIPathGenerator, _super);
    function CRMEntitySearchAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CRMEntitySearchAPIPathGenerator.search = function (entityType) {
        return this.getPath(this.CRM_ENTITIES_SEARCH, { entityType: entityType }); // GET
    };
    var _g;
    _g = CRMEntitySearchAPIPathGenerator;
    CRMEntitySearchAPIPathGenerator.BASE_CRM_ENTITIES_SEARCH = "/".concat(api_path_fragments_1.APIPathFragments.CRM, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.OBJECTS, "/:entityType/").concat(api_path_fragments_1.APIPathFragments.SEARCH);
    CRMEntitySearchAPIPathGenerator.CRM_ENTITIES_SEARCH = "".concat(_g.BASE_CRM_ENTITIES_SEARCH);
    return CRMEntitySearchAPIPathGenerator;
}(APIPathGenerator));
exports.CRMEntitySearchAPIPathGenerator = CRMEntitySearchAPIPathGenerator;
var CRMFieldAPIPathGenerator = /** @class */ (function (_super) {
    __extends(CRMFieldAPIPathGenerator, _super);
    function CRMFieldAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CRMFieldAPIPathGenerator.create = function () {
        return this.CRM_FIELDS; // POST
    };
    CRMFieldAPIPathGenerator.list = function () {
        return this.CRM_FIELDS; // POST
    };
    CRMFieldAPIPathGenerator.listSpecificEntity = function (entityType) {
        return this.getPath(this.CRM_FIELDS_SPECIFIC_ENTITY, { entityType: entityType }); // GET
    };
    CRMFieldAPIPathGenerator.listSpecificGroup = function (entityType, groupId) {
        return this.getPath(this.CRM_FIELDS_SPECIFIC_GROUP, { entityType: entityType, groupId: groupId }); // GET
    };
    CRMFieldAPIPathGenerator.details = function (entityType, fieldId) {
        return this.getPath(this.CRM_FIELDS_ITEM, { entityType: entityType, fieldId: fieldId }); // GET
    };
    CRMFieldAPIPathGenerator.update = function (entityType, fieldId) {
        return this.getPath(this.CRM_FIELDS_ITEM, { entityType: entityType, fieldId: fieldId }); // PUT
    };
    CRMFieldAPIPathGenerator["delete"] = function (entityType, fieldId) {
        return this.getPath(this.CRM_FIELDS_ITEM, { entityType: entityType, fieldId: fieldId }); // DELETE
    };
    CRMFieldAPIPathGenerator.listGroup = function () {
        return this.CRM_FIELD_GROUPS; // POST
    };
    CRMFieldAPIPathGenerator.createGroup = function () {
        return this.CRM_FIELD_GROUPS; // POST
    };
    CRMFieldAPIPathGenerator.detailsGroup = function (groupId) {
        return this.getPath(this.CRM_FIELD_GROUPS_ITEM, { groupId: groupId }); // GET
    };
    CRMFieldAPIPathGenerator.updateGroup = function (groupId) {
        return this.getPath(this.CRM_FIELD_GROUPS_ITEM, { groupId: groupId }); // PUT
    };
    CRMFieldAPIPathGenerator.deleteGroup = function (groupId) {
        return this.getPath(this.CRM_FIELD_GROUPS_ITEM, { groupId: groupId }); // DELETE
    };
    CRMFieldAPIPathGenerator.validateField = function (entityType) {
        return this.getPath(this.CRM_FIELD_VALIDATION, { entityType: entityType }); // GET
    };
    var _h;
    _h = CRMFieldAPIPathGenerator;
    CRMFieldAPIPathGenerator.BASE_CRM_FIELDS = "/".concat(api_path_fragments_1.APIPathFragments.CRM, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.FIELDS);
    CRMFieldAPIPathGenerator.CRM_FIELDS = "".concat(_h.BASE_CRM_FIELDS);
    CRMFieldAPIPathGenerator.CRM_FIELDS_ITEM = "".concat(_h.BASE_CRM_FIELDS, "/:entityType/:fieldId");
    CRMFieldAPIPathGenerator.CRM_FIELDS_SPECIFIC_ENTITY = "".concat(_h.BASE_CRM_FIELDS, "/:entityType");
    CRMFieldAPIPathGenerator.CRM_FIELDS_SPECIFIC_GROUP = "".concat(_h.BASE_CRM_FIELDS, "/g/:entityType/:groupId");
    CRMFieldAPIPathGenerator.BASE_CRM_FIELD_GROUPS = "/".concat(api_path_fragments_1.APIPathFragments.CRM, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.FIELD_GROUPS);
    CRMFieldAPIPathGenerator.CRM_FIELD_GROUPS = "".concat(_h.BASE_CRM_FIELD_GROUPS);
    CRMFieldAPIPathGenerator.CRM_FIELD_GROUPS_ITEM = "".concat(_h.BASE_CRM_FIELD_GROUPS, "/:groupId");
    CRMFieldAPIPathGenerator.BASE_CRM_FIELD_VALIDATION = "/".concat(api_path_fragments_1.APIPathFragments.CRM, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/:entityType/").concat(api_path_fragments_1.APIPathFragments.FIELD_VALIDATION);
    CRMFieldAPIPathGenerator.CRM_FIELD_VALIDATION = "".concat(_h.BASE_CRM_FIELD_VALIDATION);
    return CRMFieldAPIPathGenerator;
}(APIPathGenerator));
exports.CRMFieldAPIPathGenerator = CRMFieldAPIPathGenerator;
var CRMActivityDefinitionAPIPathGenerator = /** @class */ (function (_super) {
    __extends(CRMActivityDefinitionAPIPathGenerator, _super);
    function CRMActivityDefinitionAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CRMActivityDefinitionAPIPathGenerator.create = function () {
        return this.CRM_ACTIVITY_DEFINITIONS; // POST
    };
    CRMActivityDefinitionAPIPathGenerator.list = function () {
        return this.CRM_ACTIVITY_DEFINITIONS; // Get
    };
    CRMActivityDefinitionAPIPathGenerator.details = function (activityName) {
        return this.getPath(this.CRM_ACTIVITY_DEFINITIONS_ITEM, { activityName: activityName }); // GET
    };
    CRMActivityDefinitionAPIPathGenerator.update = function (activityName) {
        return this.getPath(this.CRM_ACTIVITY_DEFINITIONS_ITEM, { activityName: activityName }); // PUT
    };
    CRMActivityDefinitionAPIPathGenerator["delete"] = function (activityName) {
        return this.getPath(this.CRM_ACTIVITY_DEFINITIONS_ITEM, { activityName: activityName }); // DELETE
    };
    var _j;
    _j = CRMActivityDefinitionAPIPathGenerator;
    CRMActivityDefinitionAPIPathGenerator.BASE_CRM_ACTIVITY_DEFINITIONS = "/".concat(api_path_fragments_1.APIPathFragments.CRM, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.ACTIVITY_DEFINITIONS);
    CRMActivityDefinitionAPIPathGenerator.CRM_ACTIVITY_DEFINITIONS = "".concat(_j.BASE_CRM_ACTIVITY_DEFINITIONS);
    CRMActivityDefinitionAPIPathGenerator.CRM_ACTIVITY_DEFINITIONS_ITEM = "".concat(_j.BASE_CRM_ACTIVITY_DEFINITIONS, "/:activityName");
    return CRMActivityDefinitionAPIPathGenerator;
}(APIPathGenerator));
exports.CRMActivityDefinitionAPIPathGenerator = CRMActivityDefinitionAPIPathGenerator;
var CRMActivityAPIPathGenerator = /** @class */ (function (_super) {
    __extends(CRMActivityAPIPathGenerator, _super);
    function CRMActivityAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CRMActivityAPIPathGenerator.create = function () {
        return this.CRM_ACTIVITIES; // POST
    };
    CRMActivityAPIPathGenerator.list = function () {
        return this.CRM_ACTIVITIES_LIST; // Get
    };
    CRMActivityAPIPathGenerator.listSpecificType = function (activityType) {
        return this.getPath(this.CRM_ACTIVITIES_SPECIFIC_TYPE, { activityType: activityType }); // GET
    };
    CRMActivityAPIPathGenerator.listSpecificTypeSpecificEntity = function (entityType, entityId, activityType) {
        return this.getPath(this.CRM_ACTIVITIES_SPECIFIC_TYPE_SPECIFIC_ENTITY, { entityType: entityType, entityId: entityId, activityType: activityType }); // GET
    };
    CRMActivityAPIPathGenerator.details = function (activityId) {
        return this.getPath(this.CRM_ACTIVITIES_ITEM, { activityId: activityId }); // GET
    };
    CRMActivityAPIPathGenerator.update = function (activityId) {
        return this.getPath(this.CRM_ACTIVITIES_ITEM, { activityId: activityId }); // PUT
    };
    CRMActivityAPIPathGenerator["delete"] = function (activityId) {
        return this.getPath(this.CRM_ACTIVITIES_ITEM, { activityId: activityId }); // DELETE
    };
    var _k;
    _k = CRMActivityAPIPathGenerator;
    CRMActivityAPIPathGenerator.BASE_CRM_ACTIVITIES = "/".concat(api_path_fragments_1.APIPathFragments.CRM, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.ACTIVITIES);
    CRMActivityAPIPathGenerator.CRM_ACTIVITIES = "".concat(_k.BASE_CRM_ACTIVITIES);
    CRMActivityAPIPathGenerator.CRM_ACTIVITIES_ITEM = "".concat(_k.BASE_CRM_ACTIVITIES, "/:activityId");
    CRMActivityAPIPathGenerator.CRM_ACTIVITIES_SPECIFIC_TYPE = "".concat(_k.BASE_CRM_ACTIVITIES, "/").concat(api_path_fragments_1.APIPathFragments.LIST, "/:activityType");
    CRMActivityAPIPathGenerator.CRM_ACTIVITIES_SPECIFIC_TYPE_SPECIFIC_ENTITY = "".concat(_k.BASE_CRM_ACTIVITIES, "/").concat(api_path_fragments_1.APIPathFragments.LIST, "/:entityType/:entityId/:activityType");
    CRMActivityAPIPathGenerator.CRM_ACTIVITIES_LIST = "".concat(_k.BASE_CRM_ACTIVITIES, "/").concat(api_path_fragments_1.APIPathFragments.LIST);
    return CRMActivityAPIPathGenerator;
}(APIPathGenerator));
exports.CRMActivityAPIPathGenerator = CRMActivityAPIPathGenerator;
var MarketplaceAppsAPIPathGenerator = /** @class */ (function (_super) {
    __extends(MarketplaceAppsAPIPathGenerator, _super);
    function MarketplaceAppsAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketplaceAppsAPIPathGenerator.list = function () {
        return this.MARKETPLACE_APPS; // Get
    };
    MarketplaceAppsAPIPathGenerator.createInstallApp = function () {
        return this.INSTALLED_APPS; // POST
    };
    MarketplaceAppsAPIPathGenerator.listInstallApp = function () {
        return this.INSTALLED_APPS; // Get
    };
    MarketplaceAppsAPIPathGenerator.detailsInstallApp = function (appId) {
        return this.getPath(this.INSTALLED_APPS_ITEM, { appId: appId }); // GET
    };
    MarketplaceAppsAPIPathGenerator.updateInstallApp = function (appId) {
        return this.getPath(this.INSTALLED_APPS_ITEM, { appId: appId }); // PUT
    };
    MarketplaceAppsAPIPathGenerator.deleteInstallApp = function (appId) {
        return this.getPath(this.INSTALLED_APPS_ITEM, { appId: appId }); // DELETE
    };
    var _l;
    _l = MarketplaceAppsAPIPathGenerator;
    MarketplaceAppsAPIPathGenerator.BASE_MARKETPLACE_APPS = "/".concat(api_path_fragments_1.APIPathFragments.APP_INFO, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.MARKETPLACE);
    MarketplaceAppsAPIPathGenerator.MARKETPLACE_APPS = "".concat(_l.BASE_MARKETPLACE_APPS);
    MarketplaceAppsAPIPathGenerator.BASE_INSTALLED_APPS = "/".concat(api_path_fragments_1.APIPathFragments.APP_INFO, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.MARKETPLACE, "/").concat(api_path_fragments_1.APIPathFragments.INSTALLED_APPS);
    MarketplaceAppsAPIPathGenerator.INSTALLED_APPS = "".concat(_l.BASE_INSTALLED_APPS);
    MarketplaceAppsAPIPathGenerator.INSTALLED_APPS_ITEM = "".concat(_l.BASE_INSTALLED_APPS, "/:appId");
    return MarketplaceAppsAPIPathGenerator;
}(APIPathGenerator));
exports.MarketplaceAppsAPIPathGenerator = MarketplaceAppsAPIPathGenerator;
var MarketplaceAPPWhatsappWebAPIPathGenerator = /** @class */ (function (_super) {
    __extends(MarketplaceAPPWhatsappWebAPIPathGenerator, _super);
    function MarketplaceAPPWhatsappWebAPIPathGenerator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarketplaceAPPWhatsappWebAPIPathGenerator.start = function () {
        return this.MARKETPLACE_APP_WHATSAPP_WEB_START; // POST
    };
    MarketplaceAPPWhatsappWebAPIPathGenerator.stop = function () {
        return this.MARKETPLACE_APP_WHATSAPP_WEB_STOP; // POST
    };
    MarketplaceAPPWhatsappWebAPIPathGenerator.send = function () {
        return this.MARKETPLACE_APP_WHATSAPP_WEB_SEND; // POST
    };
    MarketplaceAPPWhatsappWebAPIPathGenerator.receive = function () {
        return this.MARKETPLACE_APP_WHATSAPP_WEB_RECEIVE; // POST
    };
    MarketplaceAPPWhatsappWebAPIPathGenerator.auth = function () {
        return this.MARKETPLACE_APP_WHATSAPP_WEB_AUTH; // POST
    };
    MarketplaceAPPWhatsappWebAPIPathGenerator.status = function () {
        return this.MARKETPLACE_APP_WHATSAPP_WEB_STATUS; // POST
    };
    var _m;
    _m = MarketplaceAPPWhatsappWebAPIPathGenerator;
    MarketplaceAPPWhatsappWebAPIPathGenerator.BASE_MARKETPLACE_APP_WHATSAPP_WEB = "/".concat(api_path_fragments_1.APIPathFragments.APP_INFO, "/").concat(api_path_fragments_1.APIPathFragments.V1, "/").concat(api_path_fragments_1.APIPathFragments.MARKETPLACE, "/").concat(api_path_fragments_1.APIPathFragments.INSTALLED_APPS, "/101");
    MarketplaceAPPWhatsappWebAPIPathGenerator.MARKETPLACE_APP_WHATSAPP_WEB = "".concat(_m.BASE_MARKETPLACE_APP_WHATSAPP_WEB);
    MarketplaceAPPWhatsappWebAPIPathGenerator.MARKETPLACE_APP_WHATSAPP_WEB_START = "".concat(_m.BASE_MARKETPLACE_APP_WHATSAPP_WEB, "/").concat(api_path_fragments_1.APIPathFragments.START);
    MarketplaceAPPWhatsappWebAPIPathGenerator.MARKETPLACE_APP_WHATSAPP_WEB_STOP = "".concat(_m.BASE_MARKETPLACE_APP_WHATSAPP_WEB, "/").concat(api_path_fragments_1.APIPathFragments.STOP);
    MarketplaceAPPWhatsappWebAPIPathGenerator.MARKETPLACE_APP_WHATSAPP_WEB_SEND = "".concat(_m.BASE_MARKETPLACE_APP_WHATSAPP_WEB, "/").concat(api_path_fragments_1.APIPathFragments.SEND);
    MarketplaceAPPWhatsappWebAPIPathGenerator.MARKETPLACE_APP_WHATSAPP_WEB_RECEIVE = "".concat(_m.BASE_MARKETPLACE_APP_WHATSAPP_WEB, "/").concat(api_path_fragments_1.APIPathFragments.RECEIVE);
    MarketplaceAPPWhatsappWebAPIPathGenerator.MARKETPLACE_APP_WHATSAPP_WEB_AUTH = "".concat(_m.BASE_MARKETPLACE_APP_WHATSAPP_WEB, "/").concat(api_path_fragments_1.APIPathFragments.AUTH);
    MarketplaceAPPWhatsappWebAPIPathGenerator.MARKETPLACE_APP_WHATSAPP_WEB_STATUS = "".concat(_m.BASE_MARKETPLACE_APP_WHATSAPP_WEB, "/").concat(api_path_fragments_1.APIPathFragments.STATUS);
    return MarketplaceAPPWhatsappWebAPIPathGenerator;
}(APIPathGenerator));
exports.MarketplaceAPPWhatsappWebAPIPathGenerator = MarketplaceAPPWhatsappWebAPIPathGenerator;
// // ------------------- Later ---------------------
// export class CRMManageViewsAPIPathGenerator extends APIPathGenerator {
//     public static BASE_CRM_MANAGE_VIEWS = `/${APIPathFragments.CRM}/${APIPathFragments.V1}/${APIPathFragments.MANAGE_VIEWS}`;
//     public static CRM_MANAGE_VIEWS = `${this.BASE_CRM_MANAGE_VIEWS}`;
//     public static CRM_MANAGE_VIEWS_ITEM = `${this.BASE_CRM_MANAGE_VIEWS}/:id`;
//     public static create(): string {
//         return this.CRM_MANAGE_VIEWS;  // POST
//     }
//     public static list(id: string): string {
//         return this.CRM_MANAGE_VIEWS;  // Get
//     }
//     public static details(id: string): string {
//         return this.getPath(this.CRM_MANAGE_VIEWS, { id });  // GET
//     }
//     public static update(id: string): string {
//         return this.getPath(this.CRM_MANAGE_VIEWS_ITEM, { id });  // PUT
//     }
//     public static delete(id: string): string {
//         return this.getPath(this.CRM_MANAGE_VIEWS_ITEM, { id });  // DELETE
//     }
// }
